// Mock data for Inspire Therapy Collective

export const mockContactSubmissions = [];

export const siteContent = {
  hero: {
    title: "Inspire Therapy Collective",
    tagline: "Support for the whole child — and the mother who loves them.",
    subtitle: "Therapy for Children • Teens • Women",
    body: "Warm, evidence-based therapy for children, teens, and women in Lake Nona, Orlando and throughout Florida and Virginia.",
    ctaPrimary: "Book a Free 15-Min Consult",
    ctaSecondary: "Check Insurance & Book"
  },
  
  about: {
    heading: "Meet Adrian",
    bio: [
      "I'm Adrian, a Licensed Clinical Social Worker and mom who truly understands what kids, teens, and mothers need to feel supported.",
      "With over two decades of experience in school settings, as an ABA therapist, and as a clinical practitioner, I've worked with children, teens, and families across every setting — classrooms, homes, clinics, and everything in between.",
      "I started Inspire Therapy Collective because I know firsthand how deeply a child's world affects their well-being — and how much moms feel every shift, struggle, and milestone along the way. My approach blends evidence-based care with warmth, intuition, and the kind of understanding that only comes from living this work both professionally and personally.",
      "Whether your child needs support, your teen needs a safe space, or you need a moment to breathe — I'm here."
    ],
    credentials: "Adrian Mirabile, MSW, M.Ed., LCSW",
    credentialsFull: "Licensed Clinical Social Worker · Masters in Education",
    location: "In-person in Lake Nona, Orlando FL · Telehealth across Florida and Virginia"
  },
  
  services: {
    heading: "How I Can Help",
    items: [
      {
        title: "Children",
        description: "Playful, developmentally attuned therapy for children navigating big emotions, anxiety, ADHD, behavioral challenges, or school stress. With years as a school social worker and licensed therapist, I understand the whole child across home, school, and social settings. I'm well-versed in IEPs, 504 plans, and how to advocate within school systems.",
        icon: "Sprout",
        link: "/therapy-for-children"
      },
      {
        title: "Teens",
        description: "A grounded, relatable space for teens working through identity, relationships, school pressure, social stress, or mental health struggles. Sessions are conversational and real — meeting teens where they are without judgment or lectures. I help teens build emotional tools that actually stick.",
        icon: "Heart",
        link: "/therapy-for-teens"
      },
      {
        title: "Women",
        description: "Motherhood changes everything — including your relationship with yourself. I support mothers navigating burnout, identity shifts, parenting stress, emotional overwhelm, and the quiet feeling that something needs to change. This is a space to breathe, reset, and reconnect with who you are beyond caregiving. Not just \"how are you feeling\" but \"who are you becoming.\"",
        icon: "Sun",
        link: "/therapy-for-women"
      },
      {
        title: "Education Consulting",
        description: "Navigating IEPs, 504 plans, and school systems can feel overwhelming. With over two decades of experience in school settings, I help parents understand the process, advocate for their child, and bridge the gap between clinical recommendations and classroom support.",
        icon: "GraduationCap",
        link: "/education-consulting-school-support"
      },
      {
        title: "In-Home Therapy",
        description: "Some children do their best work outside the therapy office. In-home therapy brings support directly to your family in Lake Nona — removing barriers, observing real-life dynamics, and building strategies that fit seamlessly into your daily routine.",
        icon: "Home",
        link: "/in-home-therapy-lake-nona"
      }
    ]
  },
  
  approach: {
    heading: "My Approach",
    content: "I believe therapy should feel like a homecoming — a space where you're met with compassion, not judgment.\n\nMy work weaves together evidence-based practices like CBT, ACT, and Motivational Interviewing with mindfulness, somatic awareness, and creative expression. My background as a school social worker means I understand behavior, development, school systems, IEPs, and 504 plans in a way most therapists don't.\n\nWith children, that might look like play, imagination, and meeting them in their world. With teens, it's real conversation and building skills that hold up outside the therapy room. With women, it often looks like reconnecting to intuition, naming what's been buried, and building a life that feels aligned.\n\nI believe healing doesn't happen in isolation — when you support the child, you support the family. When you support the mom, you support everyone around her.\n\nEvery session is collaborative. Every path is yours."
  },
  
  goodFit: {
    heading: "You Might Be a Good Fit If...",
    items: [
      "Your child is struggling with big emotions, anxiety, ADHD, or behavioral challenges",
      "Your child is dealing with school stress, avoidance, or difficulty adjusting",
      "Your teen is pulling away, shutting down, or navigating identity and pressure",
      "Your teen needs a trusted adult outside the family to talk to",
      "You're a mom carrying everyone else's emotions and losing yourself in the process",
      "You're experiencing burnout, overwhelm, or a life transition that feels unsteady",
      "You're a woman craving a space that feels warm, grounded, and deeply human",
      "You know something needs to shift — you're just not sure where to start"
    ],
    closingLine: "You don't have to have it all figured out to start. You just have to show up."
  },
  
  testimonial: {
    heading: "What the First Session Looks Like",
    quote: "Your first session is a chance to get to know each other. We'll talk about what brought you here, what you're hoping for, and how I can best support you or your child. There's no pressure — just a warm, honest conversation to see if we're a good fit."
  },
  
  contact: {
    heading: "Let's Connect",
    subtitle: "Ready to take the first step? Tell us who needs support — we'll reply within 1 business day.",
    location: "Lake Nona, Orlando, FL",
    telehealth: "Telehealth available throughout Florida and Virginia",
    phone: "(407) 201-9895",
    email: "amirabile@inspiretherapycollective.com"
  },
  
  footer: {
    practiceName: "Inspire Therapy Collective",
    therapist: "Adrian Mirabile, LCSW — the clinician behind Inspire Therapy Collective",
    location: "Lake Nona, Orlando, FL",
    disclaimer: "Inspire Therapy Collective provides therapy services in the states of Florida and Virginia. If you are experiencing a mental health emergency, please call 988 or go to your nearest emergency room.",
    copyright: "© 2026 Inspire Therapy Collective. All rights reserved."
  }
};

// Helper function to save contact form submissions (mock)
export const saveContactSubmission = (formData) => {
  const submission = {
    id: Date.now(),
    timestamp: new Date().toISOString(),
    ...formData
  };
  mockContactSubmissions.push(submission);
  console.log('Contact form submitted (mock):', submission);
  return submission;
};
